((Utilities) => {
	'use strict';
		
	class TabsOrganizerController {
	
		constructor($scope, $element, $timeout) {
			this.$scope 				= $scope;
			this.element 				= $element[0];
			this.$timeout 				= $timeout;
			this.actions				= $scope.scopeAttributes;
			this.data                   = $scope.DECISYON.target.content.data.mshTabsV1;
			this.ctx                   	= $scope.DECISYON.target.content.ctx;
			this._initializeVM();
			this._watchListener();
		}
		
		openPagesGroup(tabInstance){
			 let _self = this;
			 var entry ;
			 let selectedContentId = _self.actions.getSelectedContentId() || _self.data.selectedContentId;
			 selectedContentId = selectedContentId != '-1' ? selectedContentId : 0;
			 if(tabInstance == null){
				 _self.selectedIndex = _.findIndex(_self.data.resCont, (tab) => { return tab.id == selectedContentId }); //SC: to no reassing
			 }
			 if(_self.selectedIndex != -1) {
				let tab = _self.data.resCont[_self.selectedIndex];
				entry = {
				   levelLogicalName : _self.data.levelLogicalName,
				   nodeId : _self.data.nodeId,
				   nodeInfo : tab
				};
			}
			else{
				entry = {
					levelLogicalName : _self.data.levelLogicalName,
					nodeId : selectedContentId,
					nodeInfo : {
						id 		: selectedContentId,
						casType : this.ctx.selectedContentType.value,
						owner 	: this.ctx.owner.value
					}
				 };
			}
			
			_self.actions.openPage(entry, _self.data.groupId, true);
			
//	        old approach before fix entire reloading
//			let _self = this;
//			 let tab = _self.data.resCont[_self.selectedIndex];
//			 var entry = {
//				levelLogicalName : _self.data.levelLogicalName,
//				nodeId : _self.data.nodeId,
//				nodeInfo : tab
//			 };
//			_self.actions.openPage(entry, _self.data.groupId);
		}
		
		useDefaultThemeSettings(){
			return Utilities.useDefaultThemeSettings();
		}

		isTabActive(tab) {
			let _self  = this;	
			let tabActive =  _self.actions.getSelectedContentId() == tab.id;
			return tabActive;
		}
		
		_getSelectedContentId() {
			let _self  = this;
			return _self.actions.getSelectedContentId();
		}
		
		_watchListener(){
		   	let _self = this;
			let unbindWatches = [];
	 
			unbindWatches.push(_self.$scope.$watch('DECISYON.target.content.data', function(newData, oldData){
				if(!Utilities.isUndefinedOrNull(newData)){
					_self.data = newData.mshTabsV1;
					if (_self.data.resCont){
						_self.openPagesGroup();
					}
				}
			}, true));
			
//	        old approach before fix entire reloading
//			unbindWatches.push(_self.$scope.$watch('DECISYON.target.content.data', function(newData, oldData){
//				if(!Utilities.isUndefinedOrNull(newData)){
//					_self.data = newData.mshTabsV1;
//					let selectedContentId = _self.actions.getSelectedContentId() || _self.data.selectedContentId;
//					selectedContentId = selectedContentId != '-1' ? selectedContentId : 0;
//					if (_self.data.resCont){
//						_self.selectedIndex = _.findIndex(_self.data.resCont, (tab) => { return tab.id == selectedContentId });
//						if(_self.selectedIndex != -1){
//							_self.openPagesGroup();
//						}
//					}
//				}
//			}, true));
			  
			_self.$scope.$on('$destroy', function () {
	            for(var i = 0; i < unbindWatches.length; i++){
					unbindWatches[i]();
				}
	        });		
		}
	    
		_initializeVM() {
			let _self = this;
			if (_self.data.resCont){
				_self.selectedIndex = _.findIndex(_self.data.resCont, (tab) => { return tab.id == _self.data.selectedPageId });
				if(_self.selectedIndex != -1){
					_self.openPagesGroup();
				}
			}
		}
		
	}
	
	window.TabsOrganizerController = TabsOrganizerController;
	
	TabsOrganizerController.$inject = ['$scope', '$element', '$timeout'];
	angularApp.dcyApplication.register.controller('tabsOrganizerCtrl', ($scope, $element, $timeout) => new TabsOrganizerController($scope, $element, $timeout));
})(window.Utilities);